(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog-post-type-2"] && !window.DesignMode) return;
  try {
       
  $(document).ready(function(){
   var blog_type2_count = $('.blog-section .article-item').length;
      if(blog_type2_count > 2) { $('.nav_blog_type2_items').css('display','block');}
      else {$('.nav_blog_type2_items').css('display','none');}
       var blog_type2 = $(".blog-section");
       blog_type2.owlCarousel({
        items: 2,
        itemsCustom: false,
        itemsDesktop: [1199, 2],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [630, 3],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:false
      });
      // Custom Navigation Events
      $(".nav_blog_type2_items .next").click(function(){
        blog_type2.trigger('owl.next');
      })
      $(".nav_blog_type2_items .prev").click(function(){
        blog_type2.trigger('owl.prev');
      }) 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filter-grid-type-3"] && !window.DesignMode) return;
  try {
    



$("area[rel^='prettyPhoto']").prettyPhoto();
$(".gallery:first a[rel^='prettyPhoto']").prettyPhoto({animation_speed:'normal',theme:'light_square',slideshow:3000, autoplay_slideshow: false,social_tools: false,counter_separator_label: false});
$(".gallery:gt(0) a[rel^='prettyPhoto']").prettyPhoto({animation_speed:'fast',slideshow:10000, hideflash: true});

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-carousel-type-1"] && !window.DesignMode) return;
  try {
    
 $(document).ready(function(){
         var gallery_type_1_count = $('.gallery-carousel-block .gallery-carousel__items').length;
            if(gallery_type_1_count > 1) { $('.nav_gallery_type_1').css('display','block');}
            else {$('.nav_gallery_type_1').css('display','none');}
             var gallery_type_1 = $(".gallery-carousel-block");
             gallery_type_1.owlCarousel({
              items: 1,
              itemsCustom: false,
              itemsDesktop: [1199, 1],
              itemsDesktopSmall: [980, 1],
              itemsTablet: [630, 1],
              itemsTabletSmall: false,
              itemsMobile: [479, 1],
              singleItem: false,
              itemsScaleUp: false,
              responsive: true,
              responsiveRefreshRate: 200,
              responsiveBaseWidth: window,
              autoPlay: false,
              stopOnHover: false,
              navigation: false,
              pagination:false
            });
            // Custom Navigation Events
            $(".nav_gallery_type_1 .next").click(function(){
              gallery_type_1.trigger('owl.next');
            })
            $(".nav_gallery_type_1 .prev").click(function(){
              gallery_type_1.trigger('owl.prev');
            }) 
        });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-banner-type-1"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
     $("#carousel_banner").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-model-4"]) return;
  try {
    

      if (jQuery.cookie('headerTop') == 'closed') {
        jQuery('.header-top').fadeOut();
      }

      jQuery('.header-top a.close').bind('click',function(){
        jQuery('.header-top').fadeOut();
        jQuery.cookie('headerTop', 'closed', {expires:-1, path:'/'});
      });  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-grid-type-3"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
     $("#type-3__carousel_banner").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-book-style-1"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
 /*  var look__book_count = $('.look-book .look__book-items').length;
      if(look__book_count > 1) { $('.nav_lookbook_items').css('display','block');}
      else {$('.nav_lookbook_items').css('display','none');}
      var top_products = $(".look-book");
      top_products.owlCarousel({
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:false
      });
      // Custom Navigation Events
      $(".nav_lookbook_items .next").click(function(){
        look-book.trigger('owl.next');
      })
      $(".nav_lookbook_items .prev").click(function(){
        look-book.trigger('owl.prev');
      }) */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-model-1"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
$("#tab").tabpager({
//  maximum visible items
items: 7,
// CSS class for tabbed content
contents: 'contents',
// transition speed
time: 2000,
// initial tab
start: 1,
// top or bottom
position: 'top',
// scrollable
scroll: false
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-bestsellers"]) return;
  try {
    
$(document).ready(function(){
var top_products_count = $('.top-products li').length;
      if(top_products_count > 1) { $('.top_products_nav').css('display','block');}
      else {$('.top_products_nav').css('display','none');}
      var top_products = $(".top-products");
      top_products.owlCarousel({
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:false
      });
      // Custom Navigation Events
      $(".top_products_nav .next").click(function(){
        top_products.trigger('owl.next');
      })
      $(".top_products_nav .prev").click(function(){
        top_products.trigger('owl.prev');
      })             
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promoimage"]) return;
  try {
    
$(document).ready(function(){
     $("#promo-carousel").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-content-block-1"] && !window.DesignMode) return;
  try {
    
 jQuery(document).ready(function() {       
        $(".inline").colorbox({inline:true, width:"50%"});
      });

  } catch(e) { console.error(e); }
})();

})();
